import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSign, CONTROL_MODAL, SHARE_MODAL } from 'context/signview';
import { useMutation } from 'react-query';
import { fetcher } from 'api/client';
import { clientContractAction } from 'api/actions/contracts';
import { toast } from 'components/Shared/Toast';
import clsx from 'clsx';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Row,
    Col,
    ModalFooter,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    ButtonGroup
} from 'reactstrap';
import { useForm } from 'react-hook-form'

export default function ShareModal() {

    const { t } = useTranslation();

    const [{ modal, contractId, jwt }, dispatch] = useSign();

    const { register, handleSubmit, errors } = useForm({ mode: 'all' })

    const { mutate: acceptAgreementMutation } = useMutation((payload) => fetcher(clientContractAction(contractId, 'guestinvite', payload), jwt), {
        onSuccess: (data) => {
            if (data.success) {
                handleClose();
                toast.success(t('common.send_success'))
            }
        }
    })

    const handleClose = useCallback(() => dispatch({ type: CONTROL_MODAL, close: SHARE_MODAL }), [dispatch]);

    const handleSendShare = useCallback((data) => {
        acceptAgreementMutation(data)
    }, [acceptAgreementMutation]);

    return (
        <Modal isOpen={modal.includes(SHARE_MODAL)} centered>
            <Form onSubmit={handleSubmit(handleSendShare)}>
                <ModalHeader toggle={handleClose}>
                    {t('sign.participants.share')}
                </ModalHeader>
                <ModalBody>
                    <p className="text-muted mb-4">{t('sign.participants.share_modal_subtitle')}</p>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{t('sign.participants.share_modal_name')}<span className="text-primary">*</span></Label>
                                {errors?.name && <span className="text-danger text-smaller ml-2">{t('Requerido')}</span>}
                                <Input type="text" name="name" placeholder={t('sign.participants.share_modal_name_placeholder')} innerRef={register({ required: true })} />
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label>{t('sign.participants.share_modal_email')}<span className="text-primary">*</span></Label>
                                {errors?.email && <span className="text-danger text-smaller ml-2">{t('Requerido')}</span>}
                                <Input type="email" name="email" placeholder={t('sign.participants.share_modal_email_placeholder')} innerRef={register({ required: true })} />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{t('sign.participants.share_modal_phone')}</Label>
                                <Input type="text" name="phone" placeholder={t('sign.participants.share_modal_phone_placeholder')} innerRef={register} />
                            </FormGroup>
                        </Col>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <ButtonGroup className="d-flex flex-grow-1">
                        <Button onClick={handleClose}>
                            {t('sign.participants.share_modal_cancel')}
                        </Button>
                        <Button type="submit" color="primary">
                            {t('sign.participants.share_modal_send')}
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Form>
        </Modal >
    )

}